export enum EventEntity {
    Issue = 'issue',
    AppInstance = 'app_instance',
    AppSettings = 'app_settings',
    Device = 'device',
    Draft = 'draft',
    DraftEntity = 'draft_entity',
    ErpOrder = 'erp_order',
    InputIntegration = 'input_integration',
    Instrument = 'instrument',
    InstrumentLink = 'instrument_link',
    MachineGroup = 'machine_group',
    MachineModel = 'machine_model',
    MachineTool = 'machine_tool',
    MachineToolState = 'machine_tool_state',
    Measure = 'measure',
    Operation = 'operation',
    OrderAssignment = 'order_assignment',
    OrderEntity = 'order_entity',
    OrderOperation = 'order_operation',
    OrderStage = 'order_stage',
    Plan = 'plan',
    ProductUnit = 'product_unit',
    ProductionBatchOperation = 'production_batch_operation',
    ProductionBatchStage = 'production_batch_stage',
    QualityControlRequest = 'quality_control_request',
    SaleOrder = 'sale_order',
    Server = 'server',
    ShiftTask = 'shift_task',
    Technology = 'technology',
    TechnologyRoute = 'technology_route',
    UserAccount = 'user_account',
    PermissionSchemaTemplate = 'permission_schema_template',
    UserAccountRole = 'user_account_role',
    WorkTeam = 'work_team',
    IntegrationAction = 'integration_action',
}

export const EventEntityNameInCaseForm = {
    [EventEntity.Plan]: 'плана',
    [EventEntity.ErpOrder]: 'заказа',
    [EventEntity.SaleOrder]: 'заказа',
    [EventEntity.IntegrationAction]: 'интеграции',
    [EventEntity.UserAccount]: 'пользователя',
    [EventEntity.MachineTool]: 'рабочего места',
    [EventEntity.Issue]: 'заявки',
    [EventEntity.ShiftTask]: 'задания',
} as any;